import React, { Component, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';

import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

import '../../node_modules/font-awesome/scss/font-awesome.scss';

import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
// import ScrollToTop from './layout/ScrollToTop';
import authenticationRoutes from "../authenticationRoutes";

import * as loginActions from "../API/Login/loginActions";

import LicenseAgreement from "../Components/LicenseAgreement/LicenseAgreement";

import appConstants from "../appConstants";
import * as AppUtils from "../Utils/AppUtils";
import APIConfig from '../API/APIConfig';

const Login = Loadable({
	loader: () => import('../Components/Authentication/SignIn/SignIn'),
	loading: Loader
});

const AdminLayout = Loadable({
	loader: () => import('./layout/AdminLayout'),
	loading: Loader
});

const Feedback = Loadable({
	loader: () => import('../Components/Feedback/Feedback'),
	loading: Loader
});


class App extends Component 
{
	constructor(props) 
	{
		super(props);
		this.state = 
		{
			userSessionData: ((this.props.loginData && !AppUtils.isObjEmpty(this.props.loginData)) ? this.props.loginData : {})
		}
	}

	componentWillMount()
	{
		let searchParams = new URLSearchParams(window.location.search);
		if (searchParams.get('token') && searchParams.get('userId') && searchParams.get('customerDomain')) 
		{
			let customerDomain = searchParams.get('customerDomain');
			// Considered as SSO user
			var userSessionData = 
			{
				token: searchParams.get('token'),
				userId: searchParams.get('userId'),
				customerDomain: customerDomain,

				userLoginType: appConstants.LOGIN_TYPE_SAML
			}
			this.setState
			(
				{
					userSessionData: userSessionData
				}
			)
			if (window.appConfig && window.appConfig.ENABLE_DYNAMIC_API_URL)
			{
				const dynamicApiUrl = AppUtils.buildDynamicApiBaseUrl(customerDomain, window.appConfig.SERVER_URL);
				AppUtils.saveSessionStorageData(appConstants.DYNAMIC_API_BASE_URL_SESSION_STORAGE_KEY, dynamicApiUrl);
			}
			AppUtils.saveSessionStorageData(appConstants.USER_SESSION_KEY, userSessionData);
			AppUtils.saveSessionStorageData(appConstants.USER_SESSION_EXPIRED_STATUS, false);
			this.props.loginActions.fetchLoginUserDetails(userSessionData.userId);
		} else if(searchParams.get(APIConfig.SAML_TYPE_PARAM))
		{
			let samlValidationDetails =  
			{
				samlEmail: (searchParams.get(APIConfig.EMAIL_PARAM) ? searchParams.get(APIConfig.EMAIL_PARAM) : ""),
				samlAccount: (searchParams.get(APIConfig.DOMAIN_PARAM) ? searchParams.get(APIConfig.DOMAIN_PARAM) : ""),
				loginType: appConstants.LOGIN_TYPE_SAML,
				errorCode: (searchParams.get(APIConfig.SAML_ERROR_PARAM) ? parseInt(searchParams.get(APIConfig.SAML_ERROR_PARAM)) : 0),
			}
			AppUtils.saveSessionStorageData(appConstants.SAML_VALIDATION_DETAILS_SESSION_KEY, samlValidationDetails);
		} else 
		{
			this.setState
			(
				{
					userSessionData: ((this.props.loginData && !AppUtils.isObjEmpty(this.props.loginData)) ? this.props.loginData : {})
				}
			)
		}
	}

	componentWillReceiveProps(nextProps)
	{
		if((!nextProps.authenticationLoading) && nextProps.loginData != this.props.loginData)
		{
			this.setState
			(
				{
					userSessionData: nextProps.loginData
				}
			)
		}
	}

	render()
	{
		const menu = authenticationRoutes.map((route, index) => 
		{
			return (route.component) ? 
			(
				<Route
					key={index}
					path={route.path}
					exact={route.exact}
					name={route.name}
					render={props => (
						<route.component {...props} />
					)} />
			) : (null);
		});

		return (
			<Aux>
				<Suspense fallback={<Loader/>}>
					<Switch>
						{menu}
						<Route path="/feedback" component={Feedback} />
						<Route path="" component=
							{
								((this.state.userSessionData && this.state.userSessionData.userLoginType == appConstants.LOGIN_TYPE_SAML) || (this.state.userSessionData && this.state.userSessionData.licenseAgreedFlg == appConstants.CHAR_YES))
									? 
										AdminLayout 
									:
										this.state.userSessionData && this.state.userSessionData.licenseAgreedFlg == appConstants.CHAR_NO
											?
												LicenseAgreement
											:
												Login
							} />
					</Switch>
				</Suspense>
			</Aux>
		);
	}
}

const mapStateToProps = state => 
{
	return {
		authenticationLoading: state.authenticationLoading,

		loginData: state.loginDataReducer,
	}
};

const mapDispatchToProps = dispatch => 
{
	return {
		loginActions: bindActionCreators(loginActions, dispatch),
	}
};

export default connect(mapStateToProps, mapDispatchToProps) (App);
